import React from 'react'
import { Route, Switch } from 'react-router-dom'

import ProductExportsList from './ProductExportsList'

export default () => {
    return {
        routes: [
            {
                path: '/product-exports',
                render: ({ match }) => (
                    <Switch>
                        <Route path={`${match.url}`} exact component={ProductExportsList} />
                    </Switch>
                ),
            },
        ],
    }
}
